import { render, staticRenderFns } from "./Soba.vue?vue&type=template&id=4d14c67d&scoped=true"
import script from "./Soba.vue?vue&type=script&lang=js"
export * from "./Soba.vue?vue&type=script&lang=js"
import style0 from "./Soba.vue?vue&type=style&index=0&id=4d14c67d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d14c67d",
  null
  
)

export default component.exports